"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.browser = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const browser = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'browser-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4 4.80951C2.89543 4.80951 2 5.70494 2 6.80951V15.8095C2 16.9141 2.89543 17.8095 4 17.8095H16C17.1046 17.8095 18 16.9141 18 15.8095V6.80951C18 5.70494 17.1046 4.80951 16 4.80951H4ZM3.5 15.8095V8.55951L16.5 8.55951V15.8095C16.5 16.0857 16.2761 16.3095 16 16.3095H4C3.72386 16.3095 3.5 16.0857 3.5 15.8095ZM4.25 6.05951C3.83579 6.05951 3.5 6.3953 3.5 6.80951C3.5 7.22372 3.83579 7.55951 4.25 7.55951C4.66421 7.55951 5 7.22372 5 6.80951C5 6.3953 4.66421 6.05951 4.25 6.05951ZM6.75 6.05951C6.33579 6.05951 6 6.3953 6 6.80951C6 7.22372 6.33579 7.55951 6.75 7.55951C7.16421 7.55951 7.5 7.22372 7.5 6.80951C7.5 6.3953 7.16421 6.05951 6.75 6.05951ZM8.5 6.80951C8.5 6.3953 8.83579 6.05951 9.25 6.05951C9.66421 6.05951 10 6.3953 10 6.80951C10 7.22372 9.66421 7.55951 9.25 7.55951C8.83579 7.55951 8.5 7.22372 8.5 6.80951Z', fill: '#4B5563' })));
};
exports.browser = browser;
